const multipleSpacesRegEx = /\s+/g;
const characterSet =
    "a-zA-ZáàâäãåçéèêëíìîïñóòôöõúùûüýÿæœÁÀÂÄÃÅÇÉÈÊËÍÌÎÏÑÓÒÔÖÕÚÙÛÜÝŸÆŒ";
const characterSetRegEx = new RegExp(`[${characterSet}]`, "g");

export { characterSet, characterSetRegEx, multipleSpacesRegEx };
